// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddAnnouncementRecipientsController from "./add_announcement_recipients_controller"
application.register("add-announcement-recipients", AddAnnouncementRecipientsController)

import AddKidAuthorizedPersonFormController from "./add_kid_authorized_person_form_controller"
application.register("add-kid-authorized-person-form", AddKidAuthorizedPersonFormController)

import AddKidParentFormController from "./add_kid_parent_form_controller"
application.register("add-kid-parent-form", AddKidParentFormController)

import AddParentKidFormController from "./add_parent_kid_form_controller"
application.register("add-parent-kid-form", AddParentKidFormController)

import AttendanceCalendarController from "./attendance_calendar_controller"
application.register("attendance-calendar", AttendanceCalendarController)

import AttendanceFormController from "./attendance_form_controller"
application.register("attendance-form", AttendanceFormController)

import BackController from "./back_controller"
application.register("back", BackController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

import FeeSelectionController from "./fee_selection_controller"
application.register("fee-selection", FeeSelectionController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlashMessagesPositionController from "./flash_messages_position_controller"
application.register("flash-messages-position", FlashMessagesPositionController)

import LegalDocumentController from "./legal_document_controller"
application.register("legal-document", LegalDocumentController)

import LoaderController from "./loader_controller"
application.register("loader", LoaderController)

import MainNavigationController from "./main_navigation_controller"
application.register("main-navigation", MainNavigationController)

import MeestPaywall__BlikController from "./meest_paywall/blik_controller"
application.register("meest-paywall--blik", MeestPaywall__BlikController)

import MobileAppBannerController from "./mobile_app_banner_controller"
application.register("mobile-app-banner", MobileAppBannerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModeToggleController from "./mode_toggle_controller"
application.register("mode-toggle", ModeToggleController)

import MultiselectController from "./multiselect_controller"
application.register("multiselect", MultiselectController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NavigationMemoryController from "./navigation_memory_controller"
application.register("navigation-memory", NavigationMemoryController)

import PaymentStatusController from "./payment_status_controller"
application.register("payment-status", PaymentStatusController)

import PhoneNumberController from "./phone_number_controller"
application.register("phone-number", PhoneNumberController)

import PullToRefreshController from "./pull_to_refresh_controller"
application.register("pull-to-refresh", PullToRefreshController)

import PulseSubmitController from "./pulse_submit_controller"
application.register("pulse-submit", PulseSubmitController)

import QrCodeController from "./qr_code_controller"
application.register("qr-code", QrCodeController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import ReportDownloadController from "./report_download_controller"
application.register("report-download", ReportDownloadController)

import ScrollTopController from "./scroll_top_controller"
application.register("scroll-top", ScrollTopController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SwipeNavigationController from "./swipe_navigation_controller"
application.register("swipe-navigation", SwipeNavigationController)

import ToggleFreeHoursController from "./toggle_free_hours_controller"
application.register("toggle-free-hours", ToggleFreeHoursController)

import ToggleHiddenController from "./toggle_hidden_controller"
application.register("toggle-hidden", ToggleHiddenController)
